import React, { useEffect, useState } from 'react';
import './styles/Header.css';
import logo from './assets/GeoParking.png';
import { Link } from "react-scroll";
import { useNavigate } from 'react-router-dom';
import Mission from './components/Mission';
import Vision from './components/Vision';
import OurCoreValues from './components/OurCoreValues';
import Header from './components/Header';
import HeaderCompanyValues from './components/HeaderCompanyValues'

const CompanyValues = () => {
    return (
        <div>
            <HeaderCompanyValues />
            <Mission />
            <Vision />
            <OurCoreValues />
        </div>
    );
};


export default CompanyValues;
